const city = {
      "上海": [121.487899, 31.249162],
      "天津": [117.210813, 39.14393],
      "北京": [116.395645, 39.929986],
      "重庆": [106.530635, 29.544606],
      "克拉玛依": [84.92699, 45.203919],
      "拉萨 ": [91.111891, 29.662557],
      "乌鲁木齐": [87.564988, 43.84038],
      "日喀则": [88.956063, 29.26816],
      "阿拉尔": [81.291737, 40.61568],
      "图木舒克": [79.198155, 39.889223],
      "石河子": [86.041865, 44.308259],
      "阿克苏": [81.156013, 40.349444],
      "吐鲁番": [89.266025, 42.678925],
      "五家渠": [87.565449, 44.368899],
      "伊宁": [81.289048, 44.020356],
      "阿勒泰": [87.926214, 47.890136],
      "奎屯": [85.013934, 44.559557],
      "阜康": [88.305949, 44.424104],
      "博乐": [81.874285, 44.844209],
      "库尔勒": [85.709418, 41.7055],
      "银川": [106.206479, 38.502621],
      "乌苏": [84.277878, 44.407687],
      "阿图什": [76.867154, 40.13123],
      "石嘴山": [106.379337, 39.020223],
      "吴忠": [106.208254, 37.993561],
      "中卫": [105.196754, 37.521124],
      "青铜峡": [105.961462, 37.942125],
      "灵武": [106.532, 37.935175],
      "固原": [106.285268, 36.021523],
      "呼和浩特": [111.660351, 40.828319],
      "包头": [109.846239, 40.647119],
      "通辽": [122.260363, 43.633756],
      "赤峰": [118.930761, 42.297112],
      "鄂尔多斯": [109.993706, 39.81649],
      "巴彦淖尔": [107.423807, 40.76918],
      "呼伦贝尔": [119.760822, 49.201636],
      "乌兰察布": [113.112846, 41.022363],
      "霍林郭勒": [119.579748, 45.528106],
      "牙克石": [121.512668, 49.329996],
      "乌海": [106.831999, 39.683177],
      "扎兰屯": [121.929202, 47.743403],
      "根河": [121.797713, 51.375925],
      "满洲里": [117.603687, 49.500032],
      "锡林浩特": [116.136948, 44.078961],
      "丰镇": [113.308677, 40.558336],
      "乌兰浩特": [122.081534, 46.116944],
      "阿尔山": [120.357534, 47.163696],
      "二连浩特": [111.966178, 43.41778],
      "额尔古纳": [120.652764, 51.660819],
      "南宁": [108.297234, 22.806493],
      "柳州": [109.422402, 24.329053],
      "梧州": [111.305472, 23.485395],
      "桂林": [110.26092, 25.262901],
      "北海": [109.122628, 21.472718],
      "来宾": [109.231817, 23.741166],
      "崇左": [107.357322, 22.415455],
      "贺州": [111.552594, 24.411054],
      "百色": [106.631821, 23.901512],
      "钦州": [108.638798, 21.97335],
      "玉林": [110.151676, 22.643974],
      "河池": [108.069948, 24.699521],
      "防城港": [108.351791, 21.617398],
      "岑溪": [111.02872, 22.925291],
      "贵港": [109.613708, 23.103373],
      "凭祥": [106.837053, 22.093647],
      "北流": [110.467055, 22.52889],
      "合山": [108.94254, 23.802816],
      "宜州": [108.546552, 24.481177],
      "东兴": [105.202169, 29.628089],
      "桂平": [110.087119, 23.333281],
      "哈尔滨": [126.657717, 45.773225],
      "齐齐哈尔": [123.987289, 47.3477],
      "鸡西": [130.941767, 45.32154],
      "大庆": [125.02184, 46.596709],
      "佳木斯": [130.284735, 46.81378],
      "牡丹江": [129.608035, 44.588521],
      "双鸭山": [131.171402, 46.655102],
      "鹤岗": [130.292472, 47.338666],
      "五常": [127.491113, 44.772544],
      "绥化": [126.989095, 46.646064],
      "七台河": [131.019048, 45.775005],
      "尚志": [128.31617, 45.083893],
      "黑河": [127.50083, 50.25069],
      "双城": [126.20893, 45.429694],
      "密山": [132.176562, 45.469765],
      "虎林": [133.121106, 45.997276],
      "富锦": [132.539001, 47.170673],
      "铁力": [128.552517, 46.866329],
      "北安": [127.111546, 48.115946],
      "同江": [133.273328, 47.833685],
      "绥芬河": [131.102457, 44.408005],
      "海林": [129.221414, 44.903617],
      "宁安": [129.215317, 44.058017],
      "海伦": [126.897129, 47.44727],
      "肇东": [125.849731, 46.009306],
      "吉林": [126.564544, 43.871988],
      "长春": [125.313642, 43.898338],
      "安达": [125.384552, 46.535467],
      "辽源": [125.133686, 42.923303],
      "四平": [124.391382, 43.175525],
      "五大连池": [126.634501, 48.749166],
      "通化": [125.94265, 41.736397],
      "白山": [126.435798, 41.945859],
      "松原": [124.832995, 45.136049],
      "白城": [122.840777, 45.621086],
      "德惠": [125.769044, 44.510507],
      "九台": [125.985176, 44.209759],
      "舒兰": [127.116772, 44.335465],
      "榆树": [126.602501, 44.879423],
      "桦甸": [127.041392, 43.056631],
      "蛟河": [127.351742, 43.716756],
      "磐石": [126.174628, 43.057456],
      "公主岭": [124.685882, 43.791826],
      "双辽": [123.70852, 43.767695],
      "梅河口": [125.723516, 42.54265],
      "临江": [127.19171, 41.816566],
      "大安": [123.723714, 45.432438],
      "洮南": [122.453677, 45.475604],
      "集安": [125.998992, 41.251411],
      "图们": [129.834311, 43.030549],
      "敦化": [128.239499, 43.560202],
      "延吉": [129.471302, 43.059667],
      "龙井": [129.383816, 42.844249],
      "珲春": [130.702367, 43.074719],
      "和龙": [128.911211, 42.466442],
      "沈阳": [123.432791, 41.808645],
      "鞍山": [123.007763, 41.118744],
      "本溪": [123.778062, 41.325838],
      "大连": [121.593478, 38.94871],
      "丹东": [124.338543, 40.129023],
      "抚顺": [123.92982, 41.877304],
      "锦州": [121.147749, 41.130879],
      "营口": [122.233391, 40.668651],
      "盘锦": [122.073228, 41.141248],
      "铁岭": [123.85485, 42.299757],
      "阜新": [121.660822, 42.01925],
      "朝阳": [116.521695, 39.958953],
      "辽阳": [123.172451, 41.273339],
      "葫芦岛": [120.860758, 40.74303],
      "普兰": [81.530583, 30.63712],
      "新民": [122.866418, 42.016776],
      "瓦房店": [121.790699, 39.708956],
      "庄河": [122.934145, 39.85891],
      "海城": [109.165344, 21.518621],
      "东港": [119.377852, 35.469377],
      "北镇": [121.86455, 41.547118],
      "凌海": [121.285575, 41.152566],
      "盖州": [122.477327, 40.235441],
      "凤城": [124.07296, 40.57957],
      "大石桥": [122.571551, 40.646915],
      "调兵山": [123.584348, 42.44293],
      "北票": [120.811885, 41.865071],
      "灯塔": [123.312574, 41.420099],
      "开原": [124.283776, 42.471223],
      "凌源": [119.271543, 40.981801],
      "唐山": [118.183451, 39.650531],
      "兴城": [120.475527, 40.596284],
      "邯郸": [114.482694, 36.609308],
      "保定": [115.49481, 38.886565],
      "石家庄": [114.522082, 38.048958],
      "张家口": [114.893782, 40.811188],
      "沧州": [116.863806, 38.297615],
      "衡水": [115.686229, 37.746929],
      "廊坊": [116.703602, 39.518611],
      "秦皇岛": [119.604368, 39.945462],
      "晋州": [115.091738, 37.991145],
      "邢台": [114.520487, 37.069531],
      "鹰潭": [115.29875, 37.924122],
      "藁城": [114.816476, 38.054936],
      "鹿泉": [114.347323, 38.084707],
      "遵化": [117.957639, 40.137901],
      "新乐": [114.762271, 38.377578],
      "南宫": [115.47941, 37.286427],
      "迁安": [118.686955, 40.040443],
      "武安": [114.058334, 36.748995],
      "沙河": [114.283093, 36.938635],
      "安国": [115.334827, 38.39374],
      "定州": [115.057407, 38.465839],
      "高碑店": [116.040934, 39.265088],
      "任丘": [116.163214, 38.741105],
      "河间": [116.271593, 38.483721],
      "泊头": [116.389236, 38.090279],
      "涿州": [115.999054, 39.482482],
      "三河": [117.021284, 39.967428],
      "霸州": [116.574306, 39.10932],
      "黄骅": [117.400217, 38.401522],
      "济南": [117.024967, 36.682785],
      "冀州": [115.470293, 37.55607],
      "深州": [115.586699, 37.957013],
      "枣庄": [117.279305, 34.807883],
      "烟台": [121.309555, 37.536562],
      "淄博": [118.059134, 36.804685],
      "青岛": [120.384428, 36.105215],
      "日照": [119.50718, 35.420225],
      "泰安": [117.089415, 36.188078],
      "潍坊": [119.142634, 36.716115],
      "济宁": [116.600798, 35.402122],
      "莱芜": [117.684667, 36.233654],
      "威海": [122.093958, 37.528787],
      "德州": [116.328161, 37.460826],
      "菏泽": [115.46336, 35.26244],
      "临沂": [118.340768, 35.072409],
      "聊城": [115.986869, 36.455829],
      "滨州": [117.968292, 37.405314],
      "平度": [119.951062, 36.78855],
      "胶南": [119.85631, 35.852858],
      "胶州": [119.959421, 36.248031],
      "滕州": [117.147616, 35.065791],
      "莱西": [120.442831, 36.863637],
      "即墨": [120.521106, 36.487909],
      "莱阳": [120.751343, 36.905533],
      "龙口": [120.5228, 37.610401],
      "莱州": [120.001344, 37.190401],
      "蓬莱": [120.862694, 37.66116],
      "栖霞": [118.963725, 32.169424],
      "招远": [120.400517, 37.344146],
      "海阳": [121.113614, 36.861588],
      "青州": [118.470187, 36.680584],
      "安丘": [119.155992, 36.335046],
      "高密": [119.702512, 36.387318],
      "诸城": [119.41617, 36.016658],
      "昌邑": [126.326513, 44.023898],
      "兖州": [116.75256, 35.56443],
      "文登": [121.968291, 37.166083],
      "曲阜": [117.03179, 35.615761],
      "乳山": [121.529788, 36.976575],
      "邹城": [117.089582, 35.354043],
      "乐陵": [117.145553, 37.674417],
      "荣成": [122.406926, 37.128686],
      "禹城": [116.581331, 36.919143],
      "南京": [118.778074, 32.057236],
      "镇江": [119.455835, 32.204409],
      "临清": [115.782602, 36.782069],
      "徐州": [117.188107, 34.271553],
      "无锡": [120.305456, 31.570037],
      "苏州": [120.619907, 31.317987],
      "连云港": [119.173872, 34.601549],
      "扬州": [119.427778, 32.408505],
      "常州": [119.981861, 31.771397],
      "泰州": [119.919606, 32.476053],
      "南通": [120.873801, 32.014665],
      "宜兴": [119.790265, 31.362245],
      "盐城": [120.148872, 33.379862],
      "江阴": [120.310679, 31.837425],
      "邳州": [117.90306, 34.402946],
      "宿迁": [118.296893, 33.95205],
      "新沂": [118.344121, 34.284443],
      "常熟": [120.831486, 31.669446],
      "张家港": [120.627279, 31.907812],
      "溧阳": [119.382839, 31.425242],
      "金坛": [119.515038, 31.723054],
      "吴江": [120.639402, 31.014847],
      "昆山": [120.965808, 31.328937],
      "太仓": [121.158978, 31.571904],
      "海门": [121.31247, 31.956039],
      "通州": [116.740079, 39.809815],
      "大丰": [120.546274, 33.190868],
      "启东": [121.678822, 31.871302],
      "东台": [120.563769, 32.791443],
      "如皋": [120.580144, 32.273616],
      "江都": [119.701666, 32.539866],
      "仪征": [119.200955, 32.392636],
      "高邮": [119.503407, 32.835944],
      "扬中": [119.845138, 32.189469],
      "句容": [119.20708, 31.932635],
      "泰兴": [120.135346, 32.213679],
      "丹阳": [119.644304, 31.960263],
      "靖江": [120.276899, 32.039443],
      "合肥": [117.282699, 31.866942],
      "兴化": [119.996418, 32.961954],
      "姜堰": [120.090816, 32.526452],
      "芜湖": [118.384108, 31.36602],
      "淮南": [117.018639, 32.642812],
      "亳州": [115.787928, 33.871211],
      "蚌埠": [117.35708, 32.929499],
      "淮北": [116.791447, 33.960023],
      "滁州": [118.32457, 32.317351],
      "阜阳": [115.820932, 32.901211],
      "马鞍山": [118.515882, 31.688528],
      "巢湖": [117.88049, 31.608733],
      "安庆": [117.058739, 30.537898],
      "池州": [117.494477, 30.660019],
      "铜陵": [117.819429, 30.94093],
      "宣城": [118.752096, 30.951642],
      "界首": [115.398643, 33.226193],
      "天长": [118.972913, 32.721214],
      "宿州": [116.988692, 33.636772],
      "桐城": [116.953559, 30.972568],
      "明光": [118.140727, 32.811836],
      "宁国": [118.997025, 30.502936],
      "湖州": [120.137243, 30.877925],
      "嘉兴": [120.760428, 30.773992],
      "温州": [120.690635, 28.002838],
      "金华": [119.652576, 29.102899],
      "丽水": [119.929576, 28.4563],
      "宁波": [121.579006, 29.885259],
      "衢州": [118.875842, 28.95691],
      "绍兴": [120.592467, 30.002365],
      "台州": [121.440613, 28.668283],
      "舟山": [122.169872, 30.03601],
      "杭州": [120.219375, 30.259244],
      "富阳": [119.846692, 30.001094],
      "建德": [119.379533, 29.487115],
      "临安": [119.350295, 30.207684],
      "慈溪": [121.338408, 30.189257],
      "奉化": [121.377186, 29.617073],
      "余姚": [121.152779, 29.996457],
      "瑞安": [120.46834, 27.829231],
      "平湖": [121.105839, 30.716529],
      "乐清": [121.016175, 28.261839],
      "诸暨": [120.281434, 29.6994],
      "桐乡": [120.490411, 30.612341],
      "上虞": [120.889432, 29.97804],
      "嵊州": [120.761431, 29.591008],
      "海宁": [120.618727, 30.442177],
      "兰溪": [119.533338, 29.284103],
      "东阳": [120.380818, 29.237427],
      "永康": [120.108684, 28.940177],
      "义乌": [120.067296, 29.306444],
      "江山": [118.607086, 28.58197],
      "温岭": [121.421046, 28.400554],
      "龙泉": [119.082297, 28.050639],
      "三明": [117.642194, 26.270835],
      "南平": [118.181883, 26.643626],
      "厦门": [118.103886, 24.489231],
      "泉州": [118.600362, 24.901652],
      "莆田": [119.077731, 25.44845],
      "宁德": [119.542082, 26.656527],
      "漳州": [117.676205, 24.517065],
      "临海": [121.221919, 28.857389],
      "福清": [119.377547, 25.638121],
      "长乐": [119.56272, 25.915538],
      "永安": [117.328535, 25.919433],
      "龙岩": [117.017997, 25.078685],
      "福州": [119.330221, 26.047125],
      "石狮": [118.692481, 24.744894],
      "南安": [118.388981, 25.017973],
      "晋江": [118.558651, 24.729638],
      "龙海": [117.80759, 24.398817],
      "建瓯": [118.485147, 27.044914],
      "邵武": [117.480572, 27.235197],
      "武夷山": [118.011543, 27.748135],
      "建阳": [118.067793, 27.408381],
      "漳平": [117.451722, 25.379998],
      "广州": [113.30765, 23.120049],
      "福安": [119.656277, 27.055897],
      "福鼎": [120.198307, 27.224829],
      "汕头": [116.72865, 23.383908],
      "深圳": [114.025974, 22.546054],
      "佛山": [113.134026, 23.035095],
      "河源": [114.713721, 23.757251],
      "揭阳": [116.379501, 23.547999],
      "惠州": [114.410658, 23.11354],
      "梅州": [116.126403, 24.304571],
      "阳江": [111.97701, 21.871517],
      "茂名": [110.931245, 21.668226],
      "肇庆": [112.479653, 23.078663],
      "韶关": [113.594461, 24.80296],
      "珠海": [113.562447, 22.256915],
      "东莞": [113.763434, 23.043024],
      "湛江": [110.365067, 21.257463],
      "汕尾": [115.372924, 22.778731],
      "潮州": [116.630076, 23.661812],
      "增城": [113.767687, 23.346745],
      "江门": [113.078125, 22.575117],
      "清远": [113.040773, 23.698469],
      "乐昌": [113.246956, 25.244442],
      "从化": [113.684824, 23.680249],
      "开平": [112.548041, 22.374201],
      "南雄": [114.386583, 25.189905],
      "云浮": [112.050946, 22.937976],
      "台山": [112.715908, 22.034639],
      "廉江": [110.141711, 21.645265],
      "鹤山": [112.801618, 22.675317],
      "雷州 ": [110.012636, 20.796584],
      "高要": [112.461712, 23.082587],
      "恩平": [112.286461, 22.240985],
      "吴川": [110.708187, 21.441681],
      "高州": [110.975605, 22.035522],
      "陆丰": [115.78803, 22.967877],
      "兴宁": [115.7533, 24.267311],
      "四会": [112.687558, 23.431444],
      "阳春": [111.694449, 22.223898],
      "英德": [113.323169, 24.22568],
      "连州": [112.459189, 24.937021],
      "普宁": [116.078166, 23.288954],
      "化州": [110.539591, 21.845482],
      "罗定": [111.493242, 22.690984],
      "海口": [110.330802, 20.022071],
      "信宜": [111.125429, 22.431974],
      "琼海": [110.414359, 19.21483],
      "文昌": [110.780909, 19.750947],
      "万宁": [110.292505, 18.839886],
      "五指山": [109.51775, 18.831306],
      "三亚": [109.522771, 18.257776],
      "东方": [108.85101, 18.998161],
      "昆明": [102.714601, 25.049153],
      "保山": [99.177996, 25.120489],
      "昭通": [103.725021, 27.340633],
      "丽江": [100.229628, 26.875351],
      "曲靖": [103.782539, 25.520758],
      "玉溪": [102.545068, 24.370447],
      "宣威": [104.152571, 26.276829],
      "临沧": [100.092613, 23.887806],
      "安宁": [102.391127, 24.852355],
      "普洱": [100.980058, 22.788778],
      "个旧": [103.149155, 23.305692],
      "开远": [103.400155, 23.729056],
      "楚雄": [101.328638, 24.880252],
      "景洪": [100.927318, 22.111413],
      "潞西": [98.426939, 24.329497],
      "大理": [100.219209, 25.693967],
      "瑞丽": [97.811532, 24.037273],
      "贵阳": [106.709177, 26.629907],
      "六盘水": [104.852087, 26.591866],
      "遵义": [106.93126, 27.699961],
      "安顺": [105.92827, 26.228595],
      "铜仁": [109.168558, 27.674903],
      "清镇": [106.353814, 26.688621],
      "赤水": [105.920513, 28.493334],
      "毕节": [105.333323, 27.408562],
      "仁怀": [106.347908, 27.839203],
      "都匀": [107.477559, 26.153657],
      "兴义": [104.857837, 25.002544],
      "凯里": [107.948239, 26.631742],
      "绵阳": [104.705519, 31.504701],
      "福泉": [107.491217, 26.777119],
      "成都": [104.067923, 30.679943],
      "广元": [105.819687, 32.44104],
      "攀枝花": [101.722423, 26.587571],
      "德阳": [104.402398, 31.13114],
      "乐山": [103.760824, 29.600958],
      "南充": [106.105554, 30.800965],
      "自贡": [104.776071, 29.359157],
      "内江": [105.073056, 29.599462],
      "眉山": [103.84143, 30.061115],
      "泸州": [105.44397, 28.89593],
      "宜宾": [104.633019, 28.769675],
      "达州": [107.494973, 31.214199],
      "遂宁": [105.564888, 30.557491],
      "雅安": [103.009356, 29.999716],
      "邛崃": [103.376512, 30.388736],
      "崇州": [103.529467, 30.719641],
      "都江堰": [103.637342, 31.039124],
      "什邡": [104.019871, 31.293694],
      "彭州": [103.889866, 31.148577],
      "绵竹": [104.129294, 31.436657],
      "广汉": [104.298476, 31.006481],
      "华蓥": [106.759412, 30.321832],
      "江油": [104.933149, 31.952427],
      "峨眉山": [103.400912, 29.507004],
      "阆中": [106.078093, 31.602117],
      "沁阳": [104.550596, 30.372508],
      "万源": [107.993811, 31.986241],
      "西昌": [102.117888, 27.863377],
      "长沙": [112.979353, 28.213478],
      "衡阳": [112.583819, 26.898164],
      "株洲": [113.131695, 27.827433],
      "岳阳": [113.146196, 29.378007],
      "湘潭": [112.935556, 27.835095],
      "邵阳": [111.461525, 27.236811],
      "永州": [111.614648, 26.435972],
      "郴州": [113.037704, 25.782264],
      "怀化": [109.986959, 27.557483],
      "益阳": [112.366547, 28.588088],
      "娄底": [111.996396, 27.741073],
      "常德": [111.653718, 29.012149],
      "韶山": [112.533095, 27.927333],
      "湘乡": [112.355169, 27.77668],
      "张家界": [110.48162, 29.124889],
      "浏阳": [113.721985, 28.234472],
      "醴陵": [113.470625, 27.662279],
      "耒阳": [112.921552, 26.423993],
      "武冈": [110.745815, 26.786578],
      "汨罗": [113.125027, 28.801958],
      "津": [111.90685, 29.474442],
      "常宁": [112.435504, 26.365629],
      "临湘": [113.519749, 29.496146],
      "沅江": [112.564942, 28.977186],
      "资兴": [113.468522, 25.937184],
      "洪江": [110.087193, 27.239105],
      "冷水江": [111.493942, 27.684915],
      "涟源": [111.794581, 27.743727],
      "吉首": [109.770926, 28.317143],
      "襄樊": [112.176326, 32.094934],
      "宜昌": [111.310981, 30.732758],
      "鄂州": [114.895594, 30.384439],
      "黄石": [115.050683, 30.216127],
      "随州": [113.379358, 31.717858],
      "荆门": [112.21733, 31.042611],
      "十堰": [110.801229, 32.636994],
      "孝感": [113.935734, 30.927955],
      "咸宁": [114.300061, 29.880657],
      "武汉": [114.3162, 30.581084],
      "大冶": [114.846142, 30.072896],
      "黄冈": [114.906618, 30.446109],
      "丹江口": [111.193228, 32.567477],
      "当阳": [111.842712, 30.825538],
      "石首": [112.51436, 29.742222],
      "松滋": [111.696205, 30.105224],
      "宜都": [111.375534, 30.29492],
      "洪湖": [113.538915, 29.996772],
      "枣阳": [112.772607, 32.092511],
      "枝江": [111.728567, 30.451767],
      "应城": [113.55644, 30.925709],
      "宜城": [112.372745, 31.673335],
      "钟祥": [112.584826, 31.244981],
      "汉川": [113.681678, 30.622039],
      "老河口": [111.76583, 32.434166],
      "赤壁": [113.889168, 29.742561],
      "麻城": [115.089715, 31.217943],
      "广水": [113.812619, 31.682325],
      "仙桃": [113.387448, 30.293966],
      "武穴": [115.625834, 30.015614],
      "天门": [113.12623, 30.649047],
      "潜江": [112.768768, 30.343116],
      "安陆": [113.633387, 31.304355],
      "恩施": [109.517433, 30.308979],
      "利川": [108.8271, 30.239967],
      "郑州": [113.649644, 34.75661],
      "洛阳": [112.447525, 34.657368],
      "漯河": [114.046061, 33.576279],
      "新乡": [113.91269, 35.307258],
      "安阳": [114.351807, 36.110267],
      "开封": [114.351642, 34.801854],
      "周口": [114.654102, 33.623741],
      "焦作": [113.211836, 35.234608],
      "南阳": [112.542842, 33.01142],
      "信阳": [114.085491, 32.128582],
      "三门峡": [111.181262, 34.78332],
      "平顶山": [113.300849, 33.745301],
      "许昌": [113.835312, 34.02674],
      "鹤壁": [114.29777, 35.755426],
      "濮阳": [115.026627, 35.753298],
      "商丘": [115.641886, 34.438589],
      "驻马店": [114.049154, 32.983158],
      "新密": [113.439854, 34.514075],
      "荥阳": [113.351802, 34.80618],
      "巩义": [113.03959, 34.703799],
      "登封": [113.041749, 34.418362],
      "偃师": [112.734822, 34.630802],
      "汝州": [112.812717, 34.162778],
      "新郑": [113.736115, 34.459443],
      "舞钢": [113.525996, 33.289605],
      "孟州": [112.769699, 34.925884],
      "林州": [113.861084, 36.016561],
      "辉县": [113.687892, 35.543594],
      "卫辉": [114.078112, 35.499572],
      "禹州": [113.392694, 34.200308],
      "义马": [111.906093, 34.749525],
      "永城": [116.330775, 33.972013],
      "长葛": [113.855568, 34.236601],
      "灵宝": [110.779737, 34.437104],
      "邓州": [112.056861, 32.68465],
      "项城": [114.89338, 33.27447],
      "太原": [112.550864, 37.890277],
      "济源": [112.40383, 35.093893],
      "阳泉": [113.569238, 37.869529],
      "长治": [113.120292, 36.201664],
      "晋中": [112.738514, 37.693362],
      "朔州": [112.479928, 39.337672],
      "运城": [111.006854, 35.038859],
      "晋城": [112.867333, 35.499834],
      "吕梁": [111.143157, 37.527316],
      "临汾": [111.538788, 36.099745],
      "忻州": [112.727939, 38.461031],
      "高平": [112.935115, 35.809742],
      "古交": [112.107739, 37.905179],
      "介休": [111.995188, 37.025476],
      "潞城": [113.254387, 36.374406],
      "原平": [112.682128, 38.838876],
      "侯马": [111.371509, 35.621785],
      "永济": [110.488949, 34.894672],
      "河津": [110.708539, 35.631891],
      "霍州": [111.830836, 36.599678],
      "汾阳": [111.745996, 37.316764],
      "铜川": [108.968067, 34.908368],
      "孝义": [111.637646, 37.118133],
      "延安": [109.50051, 36.60332],
      "咸阳": [108.707509, 34.345373],
      "汉中": [107.045478, 33.081569],
      "宝鸡": [107.170645, 34.364081],
      "安康": [109.038045, 32.70437],
      "商洛": [109.934208, 33.873907],
      "渭南": [109.483933, 34.502358],
      "韩城": [110.393774, 35.582782],
      "榆林": [109.745926, 38.279439],
      "兴平": [108.47576, 34.307609],
      "酒泉": [98.508415, 39.741474],
      "华阴": [110.058188, 34.532718],
      "兰州": [103.823305, 36.064226],
      "天水": [105.736932, 34.584319],
      "平凉": [106.688911, 35.55011],
      "嘉峪关": [98.281635, 39.802397],
      "张掖": [100.459892, 38.93932],
      "金昌": [102.208126, 38.516072],
      "武威": [102.640147, 37.933172],
      "定西": [104.626638, 35.586056],
      "庆阳": [107.644227, 35.726801],
      "临夏": [103.200576, 35.585835],
      "玉门": [97.461209, 40.225552],
      "陇南": [104.934573, 33.39448],
      "合作": [103.085649, 34.99726],
      "敦煌": [94.158042, 40.388771],
      "西宁": [101.767921, 36.640739],
      "格尔木": [92.701667, 35.580972],
      "南昌": [115.893528, 28.689578],
      "德令哈": [97.162832, 37.727059],
      "赣州": [114.935909, 25.845296],
      "吉安": [114.992039, 27.113848],
      "九江": [115.999848, 29.71964],
      "萍乡": [113.859917, 27.639544],
      "上饶": [117.955464, 28.457623],
      "景德镇": [117.186523, 29.303563],
      "新余": [114.947117, 27.822322],
      "抚州": [116.360919, 27.954545],
      "宜春": [114.400039, 27.81113],
      "乐平": [117.273279, 28.969928],
      "瑞昌": [115.459686, 29.628545],
      "南康": [114.712561, 25.832944],
      "井冈山": [114.125439, 26.63315],
      "贵溪": [117.19787, 28.190604],
      "樟树": [115.421346, 28.002514],
      "丰城": [115.823404, 28.111516],
      "高安": [115.304482, 28.365232],
      "德兴": [117.753259, 28.940752],
      "瑞金": [115.985867, 25.921831],
      "板桥": [116.526716, 39.939098],
      "新营": [116.205959, 40.003471],
      "桃园": [115.826714, 39.701923],
      "凤山": [107.019716, 24.560065],
      "哈密": [93.529373, 42.344467],
      "喀什": [76.014343, 39.513111],
      "和田": [79.915814, 37.15335],
      "塔城": [83.190128, 46.811367],
      "昌吉": [87.073618, 44.175083],
      "伊春": [128.910766, 47.734685],
      "纳河": [128.047414, 47.356592],
      "穆林": [128.047414, 47.356592],
      "承德": [117.933822, 40.992521],
      "辛集": [115.29875, 37.924122],
      "东营": [118.583926, 37.487121],
      "章丘": [117.479345, 36.744883],
      "淮安": [119.030186, 33.606513],
      "黄山": [118.29357, 29.734435],
      "中山": [113.42206, 22.545178],
      "儋州": [109.334586, 19.574788],
      "广安": [106.63572, 30.463984],
      "资阳": [104.63593, 30.132191],
      "简阳": [104.550596, 30.372508],
      "荆州": [112.241866, 30.332591],
      "大同": [113.290509, 40.113744],
      "西安": [108.953098, 34.2778],
      "白银": [104.171241, 36.546682],
      "台北": [121.556376,25.044483],
      "台中": [120.64571,24.171926],
      "基隆": [121.749548,25.132445],
      "高雄": [120.323758,22.624566],
      "台南": [120.199576,23.004066],
      "新竹": [121.020555,24.832694],
      "嘉义": [120.461737,23.492834],
      "宜兰": [121.772545,24.734013],
      "竹北": [],
      "苗栗": [120.826234,24.565338],
      "丰原": [],
      "彰化": [120.549699,24.078527],
      "南投": [120.682505,23.920595],
      "太保": [],
      "斗六": [],
      "屏东": [120.491633,22.695003],
      "台东": [121.128639,22.765404],
      "花莲": [121.59777,23.99668],
      "马公": [],
      "香港": [114.162501,22.274911],
      "澳门": [113.554768,22.193894]
}

export default {
  city,
}



// WEBPACK FOOTER //
// ./src/assets/js/ChinaCity.js